// managersData.js

export const activeManagers = [
    {
        manager: "Chris Bode",
        teamName: "RIP rashee",
        altNames: "i lied, Kyle Pitts Sucks",
        totalRecord: "16-12-0 <-> 0-1",
        seasonRecords: {
            "2023-2024": "5-9-0",
            "2024-2025": "11-3-0",
            "2025-2026": "0-0-0"
        },
        draftPicks: {
            2023: [
                { round: 1, pick: 4, player: "Ja'Marr Chase", team: "Cin", position: "WR" },
                { round: 2, pick: 13, player: "Bijan Robinson", team: "Atl", position: "RB" },
                { round: 3, pick: 20, player: "Garrett Wilson", team: "NYJ", position: "WR" },
                { round: 4, pick: 29, player: "Jaylen Waddle", team: "Mia", position: "WR" },
                { round: 5, pick: 36, player: "Jahmyr Gibbs", team: "Det", position: "RB" },
                { round: 6, pick: 45, player: "Christian Watson", team: "GB", position: "WR" },
                { round: 7, pick: 52, player: "Trevor Lawrence", team: "Jax", position: "QB" },
                { round: 8, pick: 61, player: "Alvin Kamara", team: "NO", position: "RB" },
                { round: 9, pick: 68, player: "Jordan Addison", team: "Min", position: "WR" },
                { round: 10, pick: 77, player: "Alexander Mattison", team: "LV", position: "RB" },
                { round: 11, pick: 84, player: "Jahan Dotson", team: "Wsh", position: "WR" },
                { round: 12, pick: 93, player: "Kyle Pitts", team: "Atl", position: "TE" },
                { round: 13, pick: 100, player: "Zay Flowers", team: "Bal", position: "WR" },
                { round: 14, pick: 109, player: "J.K. Dobbins", team: "Bal", position: "RB" },
                { round: 15, pick: 116, player: "Dak Prescott", team: "Dal", position: "QB" },
                { round: 16, pick: 125, player: "Quentin Johnston", team: "LAC", position: "WR" },
                { round: 17, pick: 132, player: "Tyler Allgeier", team: "Atl", position: "RB" },
                { round: 18, pick: 141, player: "Commanders D/ST", team: "Wsh", position: "D/ST" },
                { round: 19, pick: 148, player: "Dustin Hopkins", team: "Cle", position: "K" }
            ],
            2024: [
                { round: 1, pick: 5, player: "CeeDee Lamb Dal, WR" },
                { round: 2, pick: 16, player: "Jahmyr Gibbs Det, RB" },
                { round: 3, pick: 25, player: "Michael Pittman Jr. Ind, WR" },
                { round: 4, pick: 36, player: "Jaylen Waddle Mia, WR" },
                { round: 5, pick: 45, player: "Brandon Aiyuk SF, WR" },
                { round: 6, pick: 56, player: "Malik Nabers NYG, WR" },
                { round: 7, pick: 65, player: "Dak Prescott Dal, QB" },
                { round: 8, pick: 76, player: "Rashee Rice KC, WR" },
                { round: 9, pick: 85, player: "Rhamondre Stevenson NE, RB" },
                { round: 10, pick: 96, player: "Jerome Ford Cle, RB" },
                { round: 11, pick: 105, player: "Chase Brown Cin, RB" },
                { round: 12, pick: 116, player: "Jonathon Brooks Car, RB" },
                { round: 13, pick: 125, player: "Brock Bowers LV, TE" },
                { round: 14, pick: 136, player: "Tua Tagovailoa Mia, QB" },
                { round: 15, pick: 145, player: "Bengals D/ST Cin, D/ST" },
                { round: 16, pick: 156, player: "Rico Dowdle Car, RB" },
                { round: 17, pick: 165, player: "Matt Gay Ind, K" },
            ],
            2025: [
                { round: 1, pick: 8, player: "Emily Davis", team: "KC" }
            ]
        }
    },
    {
        manager: "Dave Criss",
        teamName: "Dave's Duds",
        altNames: "-",
        totalRecord: "10-4-0 <-> 1-0",
        seasonRecords: {
            "2023-2024": "-",
            "2024-2025": "10-4-0",
            "2025-2026": "0-0-0"
        },
        draftPicks: {
            2024: [
                { round: 1, pick: 6, player: "Ja'Marr Chase Cin, WR" },
                { round: 2, pick: 15, player: "Derrick Henry Bal, RB" },
                { round: 3, pick: 26, player: "Travis Etienne Jr. Jax, RB" },
                { round: 4, pick: 35, player: "Drake London Atl, WR" },
                { round: 5, pick: 46, player: "Anthony Richardson Ind, QB" },
                { round: 6, pick: 55, player: "Trey McBride Ari, TE" },
                { round: 7, pick: 66, player: "Zamir White LV, RB" },
                { round: 8, pick: 75, player: "Jayden Reed GB, WR" },
                { round: 9, pick: 86, player: "Tony Pollard Ten, RB" },
                { round: 10, pick: 95, player: "Hollywood Brown KC, WR" },
                { round: 11, pick: 106, player: "Jameson Williams Det, WR" },
                { round: 12, pick: 115, player: "Jayden Daniels Wsh, QB" },
                { round: 13, pick: 126, player: "Zach Charbonnet Sea, RB" },
                { round: 14, pick: 135, player: "Evan McPherson Cin, K" },
                { round: 15, pick: 146, player: "Ty Chandler Min, RB" },
                { round: 16, pick: 155, player: "Giants D/ST NYG, D/ST" },
                { round: 17, pick: 166, player: "Gabe Davis Jax, WR" },
            ],
            2025: [
                { round: 1, pick: 8, player: "Emily Davis", team: "KC" }
            ]
        }
    },
    {
        manager: "Derek Coleman",
        teamName: "Ariza's Army",
        altNames: "Cowboys D Week 11",
        totalRecord: "16-12-0 <-> 0-0",
        seasonRecords: {
            "2023-2024": "8-6-0",
            "2024-2025": "8-6-0",
            "2025-2026": "0-0-0"
        },
        draftPicks: {
            2023: [
                { round: 1, pick: 5, player: "Austin Ekeler Wsh, RB" },
                { round: 2, pick: 12, player: "Saquon Barkley Phi, RB" },
                { round: 3, pick: 21, player: "Amon-Ra St. Brown Det, WR" },
                { round: 4, pick: 28, player: "Chris Olave NO, WR" },
                { round: 5, pick: 37, player: "Lamar Jackson Bal, QB" },
                { round: 6, pick: 44, player: "Dameon Pierce Hou, RB" },
                { round: 7, pick: 53, player: "Dallas Goedert Phi, TE" },
                { round: 8, pick: 60, player: "Tyler Lockett Sea, WR" },
                { round: 9, pick: 69, player: "Brandon Aiyuk SF, WR" },
                { round: 10, pick: 76, player: "Jaxon Smith-Njigba Sea, WR" },
                { round: 11, pick: 85, player: "Brian Robinson Jr. Wsh, RB" },
                { round: 12, pick: 92, player: "Jerry Jeudy Cle, WR" },
                { round: 13, pick: 101, player: "Jerick McKinnon KC, RB" },
                { round: 14, pick: 108, player: "Anthony Richardson Ind, QB" },
                { round: 15, pick: 117, player: "Cowboys D/ST Dal, D/ST" },
                { round: 16, pick: 124, player: "Michael Pittman Jr. Ind, WR" },
                { round: 17, pick: 133, player: "Zach Charbonnet Sea, RB" },
                { round: 18, pick: 140, player: "Jason Myers Sea, K" },
                { round: 19, pick: 149, player: "Jameson Williams Det, WR" },
            ],

            2024: [
                { round: 1, pick: 3, player: "Breece Hall NYJ, RB" },
                { round: 2, pick: 18, player: "Kyren Williams LAR, RB" },
                { round: 3, pick: 23, player: "De'Von Achane Mia, RB" },
                { round: 4, pick: 38, player: "DJ Moore Chi, WR" },
                { round: 5, pick: 43, player: "Cooper Kupp Sea, WR" },
                { round: 6, pick: 58, player: "James Conner Ari, RB" },
                { round: 7, pick: 63, player: "Evan Engram Den, TE" },
                { round: 8, pick: 78, player: "Christian Kirk Hou, WR" },
                { round: 9, pick: 83, player: "Raheem Mostert LV, RB" },
                { round: 10, pick: 98, player: "Diontae Johnson Bal, WR" },
                { round: 11, pick: 103, player: "Keon Coleman Buf, WR" },
                { round: 12, pick: 118, player: "Jordan Addison Min, WR" },
                { round: 13, pick: 123, player: "Caleb Williams Chi, QB" },
                { round: 14, pick: 138, player: "Tyler Allgeier Atl, RB" },
                { round: 15, pick: 143, player: "Cowboys D/ST Dal, D/ST" },
                { round: 16, pick: 158, player: "Trevor Lawrence Jax, QB" },
                { round: 17, pick: 163, player: "Greg Zuerlein NYJ, K" },
            ],

            2025: [
                { round: 1, pick: 8, player: "Emily Davis", team: "KC" }
            ]
        }
    },
    {
        manager: "Joseph Huynh",
        teamName: "Rashad's Fenmaxxers",
        altNames: "-",
        totalRecord: "4-10-0 <-> 0-0",
        seasonRecords: {
            "2023-2024": "-",
            "2024-2025": "4-10-0",
            "2025-2026": "0-0-0"
        },
        draftPicks: {
            2024: [
                { round: 1, pick: 10, player: "Saquon Barkley Phi, RB" },
                { round: 2, pick: 11, player: "Marvin Harrison Jr. Ari, WR" },
                { round: 3, pick: 30, player: "Chris Olave NO, WR" },
                { round: 4, pick: 31, player: "Dalton Kincaid Buf, TE" },
                { round: 5, pick: 50, player: "C.J. Stroud Hou, QB" },
                { round: 6, pick: 51, player: "Tank Dell Hou, WR" },
                { round: 7, pick: 70, player: "Tyjae Spears Ten, RB" },
                { round: 8, pick: 71, player: "Rome Odunze Chi, WR" },
                { round: 9, pick: 90, player: "Blake Corum LAR, RB" },
                { round: 10, pick: 91, player: "Ladd McConkey LAC, WR" },
                { round: 11, pick: 110, player: "Brian Thomas Jr. Jax, WR" },
                { round: 12, pick: 111, player: "Trey Benson Ari, RB" },
                { round: 13, pick: 130, player: "Jared Goff Det, QB" },
                { round: 14, pick: 131, player: "Chiefs D/ST KC, D/ST" },
                { round: 15, pick: 150, player: "Younghoe Koo Atl, K" },
                { round: 16, pick: 151, player: "T.J. Hockenson Min, TE" },
                { round: 17, pick: 170, player: "Adonai Mitchell Ind, WR" },
            ],

            2025: [
                { round: 1, pick: 8, player: "Emily Davis", team: "KC" }
            ]
        }
    },
    {
        manager: "Josh Boland",
        teamName: "FAFO",
        altNames: "-",
        totalRecord: "14-14-0 <-> 0-0",
        seasonRecords: {
            "2023-2024": "6-8-0",
            "2024-2025": "8-6-0",
            "2025-2026": "0-0-0"
        },
        draftPicks: {
            2023: [
                { round: 1, pick: 6, player: "Stefon Diggs Buf, WR" },
                { round: 2, pick: 11, player: "Cooper Kupp LAR, WR" },
                { round: 3, pick: 22, player: "Josh Jacobs GB, RB" },
                { round: 4, pick: 27, player: "Joe Mixon Hou, RB" },
                { round: 5, pick: 38, player: "Kirk Cousins Atl, QB" },
                { round: 6, pick: 43, player: "Mark Andrews Bal, TE" },
                { round: 7, pick: 54, player: "Mike Evans TB, WR" },
                { round: 8, pick: 59, player: "David Montgomery Det, RB" },
                { round: 9, pick: 70, player: "Geno Smith Sea, QB" },
                { round: 10, pick: 75, player: "Evan Engram Jax, TE" },
                { round: 11, pick: 86, player: "Steelers D/ST Pit, D/ST" },
                { round: 12, pick: 91, player: "Harrison Butker KC, K" },
                { round: 13, pick: 102, player: "Drake London Atl, WR" },
                { round: 14, pick: 107, player: "D'Andre Swift Chi, RB" },
                { round: 15, pick: 118, player: "Dolphins D/ST Mia, D/ST" },
                { round: 16, pick: 123, player: "Jared Goff Det, QB" },
                { round: 17, pick: 134, player: "JuJu Smith-Schuster NE, WR" },
                { round: 18, pick: 139, player: "Odell Beckham Jr. FA, WR" },
                { round: 19, pick: 150, player: "Nico Collins Hou, WR" },
            ],

            2024: [
                { round: 1, pick: 2, player: "Tyreek Hill Mia, WR" },
                { round: 2, pick: 19, player: "Davante Adams LAR, WR" },
                { round: 3, pick: 22, player: "Alvin Kamara NO, RB" },
                { round: 4, pick: 39, player: "James Cook Buf, RB" },
                { round: 5, pick: 42, player: "Josh Allen Buf, QB" },
                { round: 6, pick: 59, player: "D'Andre Swift Chi, RB" },
                { round: 7, pick: 62, player: "George Kittle SF, TE" },
                { round: 8, pick: 79, player: "Najee Harris LAC, RB" },
                { round: 9, pick: 82, player: "Jaxon Smith-Njigba Sea, WR" },
                { round: 10, pick: 99, player: "Harrison Butker KC, K" },
                { round: 11, pick: 102, player: "49ers D/ST SF, D/ST" },
                { round: 12, pick: 119, player: "J.K. Dobbins LAC, RB" },
                { round: 13, pick: 122, player: "Tyler Lockett FA, WR" },
                { round: 14, pick: 139, player: "Matthew Stafford LAR, QB" },
                { round: 15, pick: 142, player: "Dallas Goedert Phi, TE" },
                { round: 16, pick: 159, player: "Baker Mayfield TB, QB" },
                { round: 17, pick: 162, player: "Jahan Dotson Phi, WR" },
            ],

            2025: [
                { round: 1, pick: 8, player: "Emily Davis", team: "KC" }
            ]
        }
    },
    {
        manager: "Josue Ami",
        teamName: "Four Loko Army",
        altNames: "Wagon Wheel",
        totalRecord: "12-16-0 <-> 0-0",
        seasonRecords: {
            "2023-2024": "6-8-0",
            "2024-2025": "6-4-0",
            "2025-2026": "0-0-0"
        },
        draftPicks: {
            2023: [
                { round: 1, pick: 1, player: "Justin Jefferson Min, WR" },
                { round: 2, pick: 16, player: "Tony Pollard Ten, RB" },
                { round: 3, pick: 17, player: "Najee Harris Pit, RB" },
                { round: 4, pick: 32, player: "Keenan Allen Chi, WR" },
                { round: 5, pick: 33, player: "Justin Herbert LAC, QB" },
                { round: 6, pick: 48, player: "Pat Freiermuth Pit, TE" },
                { round: 7, pick: 49, player: "Breece Hall NYJ, RB" },
                { round: 8, pick: 64, player: "George Pickens Pit, WR" },
                { round: 9, pick: 65, player: "Isiah Pacheco KC, RB" },
                { round: 10, pick: 80, player: "DJ Chark Jr. Car, WR" },
                { round: 11, pick: 81, player: "Dalton Kincaid Buf, TE" },
                { round: 12, pick: 96, player: "Saints D/ST NO, D/ST" },
                { round: 13, pick: 97, player: "Dalvin Cook Bal, RB" },
                { round: 14, pick: 112, player: "Kenny Pickett Phi, QB" },
                { round: 15, pick: 113, player: "Jamaal Williams NO, RB" },
                { round: 16, pick: 128, player: "Jake Elliott Phi, K" },
                { round: 17, pick: 129, player: "Adam Thielen Car, WR" },
                { round: 18, pick: 144, player: "Jaylen Warren Pit, RB" },
                { round: 19, pick: 145, player: "Ryan Fitzpatrick Wsh, QB" },
            ],

            2024: [
                { round: 1, pick: 4, player: "Amon-Ra St. Brown Det, WR" },
                { round: 2, pick: 17, player: "Mike Evans TB, WR" },
                { round: 3, pick: 24, player: "Nico Collins Hou, WR" },
                { round: 4, pick: 37, player: "Kenneth Walker III Sea, RB" },
                { round: 5, pick: 44, player: "Jalen Hurts Phi, QB" },
                { round: 6, pick: 57, player: "David Montgomery Det, RB" },
                { round: 7, pick: 64, player: "Jaylen Warren Pit, RB" },
                { round: 8, pick: 77, player: "DeAndre Hopkins Bal, WR" },
                { round: 9, pick: 84, player: "Christian Watson GB, WR" },
                { round: 10, pick: 97, player: "David Njoku Cle, TE" },
                { round: 11, pick: 104, player: "Courtland Sutton Den, WR" },
                { round: 12, pick: 117, player: "Steelers D/ST Pit, D/ST" },
                { round: 13, pick: 124, player: "Brock Purdy SF, QB" },
                { round: 14, pick: 137, player: "Pat Freiermuth Pit, TE" },
                { round: 15, pick: 144, player: "Ka'imi Fairbairn Hou, K" },
                { round: 16, pick: 157, player: "Xavier Legette Car, WR" },
                { round: 17, pick: 164, player: "Nick Foles FA, QB" },
            ],

            2025: [
                { round: 1, pick: 8, player: "Emily Davis", team: "KC" }
            ]
        }
    },
    {
        manager: "Lindsay Cagarli",
        teamName: "The Decision Makers",
        altNames: "hot girl dream team",
        totalRecord: "19-9-0 <-> 0-1",
        seasonRecords: {
            "2023-2024": "10-4-0",
            "2024-2025": "9-5-0",
            "2025-2026": "0-0-0"
        },
        draftPicks: {
            2023: [
                { round: 1, pick: 3, player: "Tyreek Hill Mia, WR" },
                { round: 2, pick: 14, player: "A.J. Brown Phi, WR" },
                { round: 3, pick: 19, player: "Jalen Hurts Phi, QB" },
                { round: 4, pick: 30, player: "DeVonta Smith Phi, WR" },
                { round: 5, pick: 35, player: "Justin Fields Pit, QB" },
                { round: 6, pick: 46, player: "Miles Sanders Car, RB" },
                { round: 7, pick: 51, player: "George Kittle SF, TE" },
                { round: 8, pick: 62, player: "Rachaad White TB, RB" },
                { round: 9, pick: 67, player: "Christian Kirk Jax, WR" },
                { round: 10, pick: 78, player: "Raheem Mostert Mia, RB" },
                { round: 11, pick: 83, player: "Younghoe Koo Atl, K" },
                { round: 12, pick: 94, player: "Tyler Higbee LAR, TE" },
                { round: 13, pick: 99, player: "Skyy Moore KC, WR" },
                { round: 14, pick: 110, player: "Devin Singletary NYG, RB" },
                { round: 15, pick: 115, player: "Brandin Cooks Dal, WR" },
                { round: 16, pick: 126, player: "Browns D/ST Cle, D/ST" },
                { round: 17, pick: 131, player: "Antonio Gibson NE, RB" },
                { round: 18, pick: 142, player: "Rashaad Penny Phi, RB" },
                { round: 19, pick: 147, player: "Tyler Bass Buf, K" },
            ],

            2024: [
                { round: 1, pick: 9, player: "A.J. Brown Phi, WR" },
                { round: 2, pick: 12, player: "Puka Nacua LAR, WR" },
                { round: 3, pick: 29, player: "Sam LaPorta Det, TE" },
                { round: 4, pick: 32, player: "Joe Mixon Hou, RB" },
                { round: 5, pick: 49, player: "Deebo Samuel Sr. Wsh, WR" },
                { round: 6, pick: 52, player: "Zay Flowers Bal, WR" },
                { round: 7, pick: 69, player: "Joe Burrow Cin, QB" },
                { round: 8, pick: 72, player: "Calvin Ridley Ten, WR" },
                { round: 9, pick: 89, player: "Zack Moss Cin, RB" },
                { round: 10, pick: 92, player: "Devin Singletary NYG, RB" },
                { round: 11, pick: 109, player: "Ezekiel Elliott FA, RB" },
                { round: 12, pick: 112, player: "Jake Elliott Phi, K" },
                { round: 13, pick: 129, player: "Gus Edwards FA, RB" },
                { round: 14, pick: 132, player: "Saints D/ST NO, D/ST" },
                { round: 15, pick: 149, player: "Darnell Mooney Atl, WR" },
                { round: 16, pick: 152, player: "Deshaun Watson Cle, QB" },
                { round: 17, pick: 169, player: "Jaylen Wright Mia, RB" },
            ],

            2025: [
                { round: 1, pick: 8, player: "Emily Davis", team: "KC" }
            ]
        }
    },
    {
        manager: "Max Snow",
        teamName: "Run it Back",
        altNames: "Makin me Christian",
        totalRecord: "17-11-0 <-> 1-0",
        seasonRecords: {
            "2023-2024": "11-3-0",
            "2024-2025": "6-8-0",
            "2025-2026": "0-0-0"
        },
        draftPicks: {
            2023: [
                { round: 1, pick: 2, player: "Christian McCaffrey SF, RB" },
                { round: 2, pick: 15, player: "CeeDee Lamb Dal, WR" },
                { round: 3, pick: 18, player: "Patrick Mahomes KC, QB" },
                { round: 4, pick: 31, player: "Calvin Ridley Ten, WR" },
                { round: 5, pick: 34, player: "Travis Etienne Jr. Jax, RB" },
                { round: 6, pick: 47, player: "Diontae Johnson Car, WR" },
                { round: 7, pick: 50, player: "T.J. Hockenson Min, TE" },
                { round: 8, pick: 63, player: "Kenneth Walker III Sea, RB" },
                { round: 9, pick: 66, player: "Terry McLaurin Wsh, WR" },
                { round: 10, pick: 79, player: "Mike Williams NYJ, WR" },
                { round: 11, pick: 82, player: "Daniel Carlson LV, K" },
                { round: 12, pick: 95, player: "Jonathan Taylor Ind, RB" },
                { round: 13, pick: 98, player: "Deshaun Watson Cle, QB" },
                { round: 14, pick: 111, player: "Cam Akers Min, RB" },
                { round: 15, pick: 114, player: "Courtland Sutton Den, WR" },
                { round: 16, pick: 127, player: "Jets D/ST NYJ, D/ST" },
                { round: 17, pick: 130, player: "Cole Kmet Chi, TE" },
                { round: 18, pick: 143, player: "Darnell Mooney Atl, WR" },
                { round: 19, pick: 146, player: "Ezekiel Elliott NE, RB" },
            ],


            2024: [
                { round: 1, pick: 7, player: "Bijan Robinson Atl, RB" },
                { round: 2, pick: 14, player: "Jonathan Taylor Ind, RB" },
                { round: 3, pick: 27, player: "Travis Kelce KC, TE" },
                { round: 4, pick: 34, player: "DeVonta Smith Phi, WR" },
                { round: 5, pick: 47, player: "Patrick Mahomes KC, QB" },
                { round: 6, pick: 54, player: "George Pickens Pit, WR" },
                { round: 7, pick: 67, player: "Amari Cooper Buf, WR" },
                { round: 8, pick: 74, player: "Terry McLaurin Wsh, WR" },
                { round: 9, pick: 87, player: "Javonte Williams Dal, RB" },
                { round: 10, pick: 94, player: "Ravens D/ST Bal, D/ST" },
                { round: 11, pick: 107, player: "Kyler Murray Ari, QB" },
                { round: 12, pick: 114, player: "Brandon Aubrey Dal, K" },
                { round: 13, pick: 127, player: "Khalil Shakir Buf, WR" },
                { round: 14, pick: 134, player: "MarShawn Lloyd GB, RB" },
                { round: 15, pick: 147, player: "Curtis Samuel Buf, WR" },
                { round: 16, pick: 154, player: "Tyrone Tracy Jr. NYG, RB" },
                { round: 17, pick: 167, player: "Kenneth Gainwell Pit, RB" },
            ],

            2025: [
                { round: 1, pick: 8, player: "Emily Davis", team: "KC" }
            ]
        }
    },
    {
        manager: "Nick Criss",
        teamName: "Maverick",
        altNames: "MaverNick",
        totalRecord: "13-15-0 <-> 0-0",
        seasonRecords: {
            "2023-2024": "6-8-0",
            "2024-2025": "7-7-0",
            "2025-2026": "0-0-0"
        },
        draftPicks: {
            2023: [
                { round: 1, pick: 3, player: "Tyreek Hill Mia, WR" },
                { round: 2, pick: 14, player: "A.J. Brown Phi, WR" },
                { round: 3, pick: 19, player: "Jalen Hurts Phi, QB" },
                { round: 4, pick: 30, player: "DeVonta Smith Phi, WR" },
                { round: 5, pick: 35, player: "Justin Fields Pit, QB" },
                { round: 6, pick: 46, player: "Miles Sanders Car, RB" },
                { round: 7, pick: 51, player: "George Kittle SF, TE" },
                { round: 8, pick: 62, player: "Rachaad White TB, RB" },
                { round: 9, pick: 67, player: "Christian Kirk Jax, WR" },
                { round: 10, pick: 78, player: "Raheem Mostert Mia, RB" },
                { round: 11, pick: 83, player: "Younghoe Koo Atl, K" },
                { round: 12, pick: 94, player: "Tyler Higbee LAR, TE" },
                { round: 13, pick: 99, player: "Skyy Moore KC, WR" },
                { round: 14, pick: 110, player: "Devin Singletary NYG, RB" },
                { round: 15, pick: 115, player: "Brandin Cooks Dal, WR" },
                { round: 16, pick: 126, player: "Browns D/ST Cle, D/ST" },
                { round: 17, pick: 131, player: "Antonio Gibson NE, RB" },
                { round: 18, pick: 142, player: "Rashaad Penny Phi, RB" },
                { round: 19, pick: 147, player: "Tyler Bass Buf, K" },
            ],

            2024: [
                { round: 1, pick: 8, player: "Justin Jefferson Min, WR" },
                { round: 2, pick: 13, player: "Garrett Wilson NYJ, WR" },
                { round: 3, pick: 28, player: "Rachaad White TB, RB" },
                { round: 4, pick: 33, player: "Josh Jacobs GB, RB" },
                { round: 5, pick: 48, player: "Lamar Jackson Bal, QB" },
                { round: 6, pick: 53, player: "Aaron Jones Min, RB" },
                { round: 7, pick: 68, player: "Tee Higgins Cin, WR" },
                { round: 8, pick: 73, player: "Keenan Allen Chi, WR" },
                { round: 9, pick: 88, player: "Jake Ferguson Dal, TE" },
                { round: 10, pick: 93, player: "Browns D/ST Cle, D/ST" },
                { round: 11, pick: 108, player: "Austin Ekeler Wsh, RB" },
                { round: 12, pick: 113, player: "Justin Tucker Bal, K" },
                { round: 13, pick: 128, player: "Aaron Rodgers FA, QB" },
                { round: 14, pick: 133, player: "Jerry Jeudy Cle, WR" },
                { round: 15, pick: 148, player: "Dalton Schultz Hou, TE" },
                { round: 16, pick: 153, player: "Jakobi Meyers LV, WR" },
                { round: 17, pick: 168, player: "Romeo Doubs GB, WR" },
            ],

            2025: [
                { round: 1, pick: 8, player: "Emily Davis", team: "KC" }
            ]
        }
    },
    {
        manager: "Shahdad Parsi",
        teamName: "Beats By Ray",
        altNames: "-",
        totalRecord: "1-13-0 <-> 0-0",
        seasonRecords: {
            "2023-2024": "-",
            "2024-2025": "1-13-0",
            "2025-2026": "0-0-0"
        },
        draftPicks: {
            2024: [
                { round: 1, pick: 1, player: "Christian McCaffrey SF, RB" },
                { round: 2, pick: 20, player: "Isiah Pacheco KC, RB" },
                { round: 3, pick: 21, player: "DK Metcalf Pit, WR" },
                { round: 4, pick: 40, player: "Stefon Diggs Hou, WR" },
                { round: 5, pick: 41, player: "Mark Andrews Bal, TE" },
                { round: 6, pick: 60, player: "Jordan Love GB, QB" },
                { round: 7, pick: 61, player: "Chris Godwin TB, WR" },
                { round: 8, pick: 80, player: "Brian Robinson Jr. Wsh, RB" },
                { round: 9, pick: 81, player: "Kyle Pitts Atl, TE" },
                { round: 10, pick: 100, player: "Xavier Worthy KC, WR" },
                { round: 11, pick: 101, player: "Jets D/ST NYJ, D/ST" },
                { round: 12, pick: 120, player: "Jake Moody SF, K" },
                { round: 13, pick: 121, player: "Nick Chubb Cle, RB" },
                { round: 14, pick: 140, player: "Kirk Cousins Atl, QB" },
                { round: 15, pick: 141, player: "Antonio Gibson NE, RB" },
                { round: 16, pick: 160, player: "DeMario Douglas NE, WR" },
                { round: 17, pick: 161, player: "Jaleel McLaughlin Den, RB" },
            ],

            2025: [
                { round: 1, pick: 8, player: "Emily Davis", team: "KC" }
            ]
        }
    }
    // Add more active managers...
];

export const formerManagers = [
    {
        manager: "Gus O'Brien",
        teamName: "Team Ireland",
        altNames: "-",
        totalRecord: "4-10-0 <-> 0-0",
        seasonRecords: {
            "2023-2024": "4-10-0",
            "2024-2025": "-",
            "2025-2026": "-"
        },
        draftPicks: {
            2023: [
                { round: 1, pick: 8, player: "Travis Kelce KC, TE" },
                { round: 2, pick: 9, player: "Nick Chubb Cle, RB" },
                { round: 3, pick: 24, player: "Joe Burrow Cin, QB" },
                { round: 4, pick: 25, player: "Tee Higgins Cin, WR" },
                { round: 5, pick: 40, player: "Amari Cooper Cle, WR" },
                { round: 6, pick: 41, player: "Rhamondre Stevenson NE, RB" },
                { round: 7, pick: 56, player: "Chris Godwin TB, WR" },
                { round: 8, pick: 57, player: "DJ Moore Chi, WR" },
                { round: 9, pick: 72, player: "Justin Tucker Bal, K" },
                { round: 10, pick: 73, player: "Marquise Brown KC, WR" },
                { round: 11, pick: 88, player: "Tua Tagovailoa Mia, QB" },
                { round: 12, pick: 89, player: "Bills D/ST Buf, D/ST" },
                { round: 13, pick: 104, player: "David Njoku Cle, TE" },
                { round: 14, pick: 105, player: "Javonte Williams Den, RB" },
                { round: 15, pick: 120, player: "AJ Dillon GB, RB" },
                { round: 16, pick: 121, player: "Gabe Davis Jax, WR" },
                { round: 17, pick: 136, player: "Samaje Perine Den, RB" },
                { round: 18, pick: 137, player: "Jakobi Meyers LV, WR" },
                { round: 19, pick: 152, player: "Gus Edwards LAC, RB" },
            ],

            2024: [
                { round: 1, pick: 5, player: "CeeDee Lamb Dal, WR" },
                { round: 2, pick: 16, player: "Jahmyr Gibbs Det, RB" },
                { round: 3, pick: 25, player: "Michael Pittman Jr. Ind, WR" },
                { round: 4, pick: 36, player: "Jaylen Waddle Mia, WR" },
                { round: 5, pick: 45, player: "Brandon Aiyuk SF, WR" },
                { round: 6, pick: 56, player: "Malik Nabers NYG, WR" },
                { round: 7, pick: 65, player: "Dak Prescott Dal, QB" },
                { round: 8, pick: 76, player: "Rashee Rice KC, WR" },
                { round: 9, pick: 85, player: "Rhamondre Stevenson NE, RB" },
                { round: 10, pick: 96, player: "Jerome Ford Cle, RB" },
                { round: 11, pick: 105, player: "Chase Brown Cin, RB" },
                { round: 12, pick: 116, player: "Jonathon Brooks Car, RB" },
                { round: 13, pick: 125, player: "Brock Bowers LV, TE" },
                { round: 14, pick: 136, player: "Tua Tagovailoa Mia, QB" },
                { round: 15, pick: 145, player: "Bengals D/ST Cin, D/ST" },
                { round: 16, pick: 156, player: "Rico Dowdle Car, RB" },
                { round: 17, pick: 165, player: "Matt Gay Ind, K" },
            ],
            2025: [
                { round: 1, pick: 8, player: "Emily Davis", team: "KC" }
            ]
        }
    }
    // Add more former managers...
];
